import { ImageRepository } from '../../domain/repositories/image.repository';

export class DeleteImageUseCase {
  constructor(private readonly imageRepository: ImageRepository) {}

  public async execute(id: string): Promise<void> {
    return this.imageRepository.deleteImage(id);
  }
}
